import React from 'react';
import Spinner, { SpinnerSize } from 'components/Spinner';
import { Backdrop } from './styles';
import { PropTypes } from 'prop-types';
import Colors from 'constants/Colors';

const propTypes = {
  spinnerSize: PropTypes.oneOf([
    SpinnerSize.SMALL,
    SpinnerSize.MEDIUM,
    SpinnerSize.BIG
  ]),
  spinnerColor: PropTypes.string,
  backdropColor: PropTypes.string,
  opacity: PropTypes.number,
  fullScreen: PropTypes.bool
};

const defaultProps = {
  spinnerSize: SpinnerSize.SMALL,
  spinnerColor: null,
  backdropColor: Colors.PRIMARY,
  opacity: 0.5,
  fullScreen: false
};

export default function Loader({
  spinnerSize,
  spinnerColor,
  backdropColor,
  opacity,
  fullScreen
}) {
  return (
    <Backdrop color={backdropColor} opacity={opacity} fullScreen={fullScreen}>
      <Spinner size={spinnerSize} color={spinnerColor} />
    </Backdrop>
  );
}

Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;
